import { render, staticRenderFns } from "./DescribeBlock.vue?vue&type=template&id=f817f6d4&scoped=true"
import script from "./DescribeBlock.vue?vue&type=script&lang=js"
export * from "./DescribeBlock.vue?vue&type=script&lang=js"
import style0 from "./DescribeBlock.vue?vue&type=style&index=0&id=f817f6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f817f6d4",
  null
  
)

export default component.exports